import { Box } from "@chakra-ui/react";
import HostView from "@components/Host/HostView";
import { NotFoundError, ZoomAppAuthFailed } from "@components/Errors";
import {
  Login,
  ZoomInstallation,
  Register,
  ConfirmEmail,
  ResetPassword,
  NewPassword,
  CheckEmail,
  VerifyEmail,
  Onboarding,
  Setup,
  AccountView,
  Home,
  OldAgendaView,
  NewAgendaView,
  AgendaDetailView,
  BillingView,
  EditProfile,
  WebUserJoinMeeting,
  SendToolRedirect,
  WebMeetingJoin,
  SmartAgendas,
  ReportsView,
  ReportDetailView,
  NewsView,
  RouteRedirector,
  TrySmartAgenda,
} from "@routes/lazyImports";
import { getRouteNames, removeExcludedRoutes } from "./utils";
import { APP_TYPE } from "@constants";

export const routeConfigurations = {
  rootPage: {
    component: RouteRedirector,
    path: "/",
  },
  loginPage: {
    component: Login,
    path: "/login",
    exclude: [APP_TYPE.ZoomApp],
  },
  zoomInstallationPage: {
    component: ZoomInstallation,
    path: "/zoomapp",
  },
  registerPage: {
    component: Register,
    path: "/register",
    exclude: [APP_TYPE.ZoomApp],
  },
  confirmEmailPage: {
    component: ConfirmEmail,
    path: "/confirm-email/:email",
    exclude: [APP_TYPE.ZoomApp],
  },
  resetPasswordPage: {
    component: ResetPassword,
    path: "/reset-password",
    exclude: [APP_TYPE.ZoomApp],
  },
  checkEmailPage: {
    component: CheckEmail,
    path: "/check-email",
    exclude: [APP_TYPE.ZoomApp],
  },
  createPasswordPage: {
    component: NewPassword,
    path: "/create-password",
    exclude: [APP_TYPE.ZoomApp],
  },
  setupPage: {
    component: Setup,
    requiresAuthentication: true,
    path: "/setup",
  },
  accountPage: {
    component: AccountView,
    requiresAuthentication: true,
    path: "/account/*",
    subPages: {
      editProfilePage: {
        path: "/edit-profile",
        component: EditProfile,
      },
      billingPage: {
        path: "/billing",
        component: BillingView,
      },
    },
  },
  onboardingPage: {
    component: Onboarding,
    requiresAuthentication: true,
    path: "/onboarding",
  },
  verifyAccountPage: {
    component: VerifyEmail,
    path: "/account/verify",
    exclude: [APP_TYPE.ZoomApp],
  },

  webUserJoinMeetingPage: {
    component: WebUserJoinMeeting,
    requiresAuthentication: true,
    path: "/meeting",
  },
  webMeetingJoinPage: {
    component: WebMeetingJoin,
    requiresAuthentication: true,
    path: "/join/:code",
  },
  proPage: {
    component: HostView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro",
  },
  allAgendaPage: {
    component: HostView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro/agendas",
  },
  smartAgendasPage: {
    component: SmartAgendas,
    requiresAuthentication: true,
    path: "/pro/smart-agendas",
  },
  reportsPage: {
    component: ReportsView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro/reports",
  },
  reportDetailPage: {
    component: ReportDetailView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro/reports/:agendaId",
  },
  newsPage: {
    component: NewsView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro/news",
  },
  agendaDetailPage: {
    component: AgendaDetailView,
    requiresAuthentication: true,
    showIconViewer: true,
    path: "/pro/agendas/:agendaId",
  },
  // Phase 2 (guest demo): public routes so an anonymous visitor can run the
  // real demo without a RequireAuth bounce. Same components, demo mode driven
  // by the guest token / ?demo=true.
  publicDemoAgendaPage: {
    component: AgendaDetailView,
    showIconViewer: true,
    path: "/demo/:agendaId",
  },
  publicDemoReportPage: {
    component: ReportDetailView,
    showIconViewer: true,
    path: "/demo/:agendaId/report",
  },
  newAgendaDetailPage: {
    component: OldAgendaView,
    requiresAuthentication: true,
    // isPro: true,
    path: "/pro/agendas-old/:agendaId",
  },
  zoomAppAuthorizationFailedPage: {
    component: ZoomAppAuthFailed,
    exclude: [APP_TYPE.WebApp],
    path: "/error/authorization",
  },
  trySmartAgendaPage: {
    component: TrySmartAgenda,
    path: "/try-smart-agenda",
    exclude: [APP_TYPE.ZoomApp],
  },
  sendToolRedirectPage: {
    component: SendToolRedirect,
    container: Box,
    path: "/send-link",
    exclude: [APP_TYPE.ZoomApp],
  },
  errorPage: {
    component: NotFoundError,
    path: "*",
  },
};

export const routeConfig = removeExcludedRoutes(routeConfigurations);

export const $Routes = getRouteNames(routeConfigurations);
